module.exports = "<a ng-class=\"classes\" ng-click=\"OauthButtons.loginOauth('facebook')\" class=\"btn btn-social btn-facebook\">\n  <i class=\"fa fa-facebook\"></i>\n  Facebook\n</a>\n<!-- a ng-class=\"classes\" ng-click=\"OauthButtons.loginOauth('google')\" class=\"btn btn-social btn-google\">\n  <i class=\"fa fa-google-plus\"></i>\n  Connect with Google+\n</a -->\n<a ng-class=\"classes\" ng-click=\"OauthButtons.loginOauth('twitter')\" class=\"btn btn-social btn-twitter\">\n  <i class=\"fa fa-twitter\"></i>\n  Twitter\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/oauth-buttons/oauth-buttons.html
// module id = 196
// module chunks = 0